<template>
   <div class="home-info">
                    <div>
                        <div class="number">{{this.active}}</div>
                        <div class="name red">Created</div>
                    </div>
                    <div>
                        <div class="number">{{this.finished}}</div>
                        <div class="name yellow">Finished</div>
                    </div>
                    <div>
                        <div class="number">{{this.approved}}</div>
                        <div class="name green">Approved</div>
                    </div>
                </div>
</template>

<script>
export default {
  computed: {
    style() {
      return 'height: ' + this.height + '%';
    }
  },
  props: {
    height: String,
    finished:0,
    active:0,
    approved:0,

  },
};
</script>

<style lang="scss" scoped>  
@import "@/style/base.scss";
@import "@/style/components/sideBoxV2.scss";
@import "@/style/components/home.scss";

.side_box {
  max-height: 440px;
}
</style>
